import { combineReducers } from 'redux';

import server from './reducers/server';
import filters from './reducers/filter';
import upload from './reducers/upload';

const organizationReducers = combineReducers({
	server,
	filters,
	upload,
});

export default organizationReducers;


// WEBPACK FOOTER //
// ./src/organizations/reducers.js